import React from 'react';
import { IconSvgProps } from '@models/common';

const NavAiChat: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.25 4.125H3.75C3.25272 4.125 2.77581 4.32254 2.42418 4.67417C2.07255 5.02581 1.875 5.50272 1.875 6V21C1.8735 21.3571 1.97492 21.707 2.16712 22.0079C2.35932 22.3089 2.63416 22.5481 2.95875 22.6969C3.20788 22.8136 3.47955 22.8744 3.75469 22.875C4.19498 22.8739 4.62071 22.7172 4.95656 22.4325L4.96781 22.4222L7.91906 19.875H20.25C20.7473 19.875 21.2242 19.6775 21.5758 19.3258C21.9275 18.9742 22.125 18.4973 22.125 18V6C22.125 5.50272 21.9275 5.02581 21.5758 4.67417C21.2242 4.32254 20.7473 4.125 20.25 4.125ZM19.875 17.625H7.5C7.22999 17.6245 6.96892 17.7218 6.765 17.8988L4.125 20.1778V6.375H19.875V17.625Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default NavAiChat;
